import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { CommunicationsDocument, GlobalActions } from '../../model';
import {
  downloadCommunicationDocuments,
  getCommunicationDocumentsState,
  communicationsDocumentsActions,
} from '../../store/features/documents';
import { messagesForCommunicationDocumentsError } from '../../store/features/documents/communications/communications-utils';
import { useAppDispatch, useAppSelector } from '../redux';

export interface CommunicationDocumentsTabLogic {
  communications: CommunicationsDocument[];
  isRequestLoading: boolean;
}

export const useCommunicationDocumentsTabLogic = (
  globalActions: GlobalActions
): CommunicationDocumentsTabLogic => {
  const { showToast, closeToast } = globalActions;
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const { communications, communicationsRequestStatus, communicationsError }:any =
    useAppSelector(getCommunicationDocumentsState);
  const [
    downloadCommunicationsCallingRequest,
    setDownloadCommunicationsCallingRequest,
  ] = useState(0);

  useEffect(() => {
    if (
      downloadCommunicationsCallingRequest === 0 &&
      !communications &&
      communicationsRequestStatus !== 'loading'
    ) {
      setDownloadCommunicationsCallingRequest(
        downloadCommunicationsCallingRequest + 1
      );
      dispatch(downloadCommunicationDocuments());
    }
  }, [
    dispatch,
    communications,
    communicationsRequestStatus,
    downloadCommunicationsCallingRequest,
  ]);

  useEffect(() => {
    if (communicationsError) {
      const errorMessages =
        messagesForCommunicationDocumentsError(communicationsError);
      showToast({
        type: 'error',
        title: formatMessage(errorMessages.title),
        description:
          errorMessages.description && formatMessage(errorMessages.description),
        close: closeToast,
      });
      dispatch(communicationsDocumentsActions.clearError());
    }
  }, [dispatch, communicationsError, closeToast, formatMessage, showToast]);

  return {
    communications,
    isRequestLoading: communicationsRequestStatus === 'loading',
  };
};
